/**
 * Copy paste from apply-api-library: https://github.com/Avela-Education/apply-api/tree/dev/lambda/apply-api-library/src/brandings
 * TODO: Move this into DB
 */
// Trick to get html syntax highlighting in vscode
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
export const html = (strings: any, ...values: any) =>
  String.raw({ raw: strings }, ...values);
